import { SelectStatusType } from '../internal';
import { getFlatOptions } from '../../../dropdown/src/utils/options';
import FilteringHandler from './filtering-handler';
import InteractionHandler from './interaction-handler';
var BaseSelectController = /** @class */ (function () {
    function BaseSelectController(componentInstance) {
        var _this = this;
        this.loadMoreHandler = function (event) {
            event.stopPropagation();
            if (_this.component.options.length > 0 && _this.component.statusType === SelectStatusType.PENDING) {
                _this.component.__fireEvent('loadMore');
            }
        };
        this.component = componentInstance;
        this.interactionHandler = new InteractionHandler(componentInstance);
        this.filteringHandler = new FilteringHandler(componentInstance);
    }
    BaseSelectController.prototype.attached = function () {
        this.interactionHandler.addListeners();
        this.filteringHandler.addListeners();
    };
    BaseSelectController.prototype.detached = function () {
        this.interactionHandler.removeListeners();
        this.filteringHandler.removeListeners();
    };
    BaseSelectController.prototype.getTriggerComponent = function () {
        return this.component.node.querySelector('awsui-select-trigger').component;
    };
    BaseSelectController.prototype.getDropdownComponent = function () {
        return this.component.node.querySelector('awsui-select-dropdown').component;
    };
    BaseSelectController.prototype.getFilterComponent = function () {
        return this.component.node.querySelector('awsui-select-filter').component;
    };
    BaseSelectController.prototype.getFilterInput = function () {
        return this.getFilterComponent().node.querySelector('input');
    };
    BaseSelectController.prototype.closeDropdown = function (loseFocus) {
        // if we're closing because we're losing focus, and the focus isn't currently on the trigger element
        // we want to manually fire a blur event
        if (loseFocus && this.component.__open && !this.getTriggerComponent().node.contains(document.activeElement)) {
            this.component.__fireEvent('blur');
        }
        this.component.__open = false;
        this.component.__highlightedOption = null;
    };
    BaseSelectController.prototype.openDropdown = function () {
        if (this.component.disabled) {
            return;
        }
        this.component.__open = true;
        if (this.component.__filteringText !== '') {
            this.component.__filteringText = '';
            this.notifyFilteringChange();
        }
        this.interactionHandler.focusActiveElement();
    };
    BaseSelectController.prototype.getVisibleOptions = function () {
        return this.filteringHandler.getFilterMatchingOptions();
    };
    BaseSelectController.prototype.getEnabledOptions = function (onlyVisible) {
        var options = onlyVisible ? this.getVisibleOptions() : this.component.options;
        return getFlatOptions(options, false);
    };
    BaseSelectController.prototype.getEmptyTextRegion = function () {
        return this.hasAutoFiltering() && this.component.__filteringText ? 'noMatch' : 'empty';
    };
    BaseSelectController.prototype.shouldDisplayFilter = function () {
        return ((this.hasAutoFiltering() && this.component.options.length > 0) ||
            this.component.filteringType === "manual" /* MANUAL */);
    };
    BaseSelectController.prototype.hasAutoFiltering = function () {
        return this.component.enableFiltering || this.component.filteringType === "auto" /* AUTO */;
    };
    BaseSelectController.prototype.notifyFilteringChange = function () {
        this.component.__fireEvent('delayedFilteringChange', { value: this.component.__filteringText });
    };
    return BaseSelectController;
}());
export default BaseSelectController;
//# sourceMappingURL=base-select-controller.js.map